import { Heart, PhoneCall, Sparkles } from "lucide-react";
import { InquiryForm } from "@/components/site/InquiryForm";
import { PageHero } from "@/components/site/PageHero";
import { SiteLayout } from "@/components/site/SiteLayout";

export default function VitalityInquiry() {
  return (
    <SiteLayout>
      <PageHero
        currentPage="Vitality Inquiry"
        eyebrow="Ask about Vitality"
        title={<>Keep more of life within <em>reach.</em></>}
        description="If Vitality sounds like the kind of support you have been looking for, share four contact details. The office will call with class information and answer your questions."
        tone="green"
      />
      <section className="page-section vitality-inquiry-section">
        <div className="container inquiry-page-grid">
          <div className="vitality-inquiry-copy">
            <p className="section-kicker">This inquiry is only for Vitality</p>
            <h2>One short form. A real conversation.</h2>
            <p>This form follows a separate Vitality workflow so your message does not get mixed into a general physical therapy inquiry.</p>
            <div className="vitality-inquiry-points">
              <span><Heart /> Built for adults 50+</span>
              <span><Sparkles /> Focused on strength, confidence, and possibility</span>
              <span><PhoneCall /> Class details shared during a personal follow-up</span>
            </div>
          </div>
          <InquiryForm kind="vitality" />
        </div>
      </section>
    </SiteLayout>
  );
}
